module.exports = __webpack_public_path__ + "static/giraffe-66c1c3cc74fa68011a21b40bc2572f0b.svg";